import React from 'react';
import { iconAddCircle } from '../../assets';

export interface OptinCardProps {
  promoContent: string;
  onClick: () => void;
}

const OptinCard = ({ promoContent, onClick }: OptinCardProps) => {
  return (
    <div className="optin-card-border">
      <div className="optin-card">
        <button type="button" onClick={onClick}>
          <div className="optin-card__content">
            <p className="optin-card__content--description" dangerouslySetInnerHTML={{ __html: promoContent || '' }} />
            <hr className="colored-hr" />
            <div className="optin-card__button-participate">
              <div className="optin-card__button-participate__icon">
                <img src={iconAddCircle} alt="icone" />
              </div>
              <button type="button" onClick={onClick}>
                Quero Participar!
              </button>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default OptinCard;
